import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      setUser: (user) => set({ user, isAuthenticated: !!user }),
      logout: () => {
        localStorage.removeItem('session_token');
        set({ user: null, isAuthenticated: false });
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ user: state.user, isAuthenticated: state.isAuthenticated }),
    }
  )
);

export const useAttemptStore = create((set) => ({
  currentAttempt: null,
  autoSaveTimer: null,
  setCurrentAttempt: (attempt) => set({ currentAttempt: attempt }),
  clearCurrentAttempt: () => set({ currentAttempt: null }),
  startAutoSave: (callback) => {
    const timer = setInterval(callback, 10000);
    set({ autoSaveTimer: timer });
  },
  stopAutoSave: () => set((state) => {
    if (state.autoSaveTimer) {
      clearInterval(state.autoSaveTimer);
    }
    return { autoSaveTimer: null };
  }),
}));
